var pageId = "users-completions-new";

$(document).on("pjaxload#" + pageId, function(e, $page, page) {
  $page.find(".form").on("ajax:error", function(e, result) {
    if (result.responseJSON.html) {
      simple.dialog({
        content: result.responseJSON.html,
        cls: "dialog-user-mergence",
        buttons: null,
        showRemoveButton: true
      });
    }
  });
});
